import {useLocation} from 'react-router-dom';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import getServiceUrl from '../../../utilities/get-service-url';

const impulseServiceByIdQuery = graphql`
    query useImpulseServiceServiceByIdQuery($serviceId: String, $include: Boolean = true) {
        serviceById(id: $serviceId) @include(if: $include) {
            id
            end
            mrchntd
            name
            nameUk
            target
            description
            slug
            start
            strategy
            every
            warp
            pools {
                id
            }
            endpoints {
                id
                labels
            }
        }
    }
`;

const useImpulseService = ({serviceId}) => {
    const location = useLocation();
    const {serviceById} = useLazyLoadQuery(
        impulseServiceByIdQuery,
        {serviceId: serviceId, include: !!serviceId}
    );
    const serviceUrl = serviceById ? getServiceUrl({description: serviceById.description, id: serviceById.id, slug: serviceById.slug, warp: serviceById.warp, location}) : '';
    return {
        serviceById,
        serviceUrl
    };
};

export default useImpulseService;
